import { useState } from "react";
import { toast } from "sonner";
import RegistrationForm from "@/components/RegistrationForm";
import { Button } from "@/components/ui/button";
import { Link2, Check } from "lucide-react";

export default function NewRegistration() {
  const [copied, setCopied] = useState(false);
  const shareUrl = `${window.location.origin}/apply`;

  const copyLink = () => {
    navigator.clipboard.writeText(shareUrl);
    setCopied(true);
    toast.success("Public link copied");
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="max-w-2xl mx-auto space-y-6" data-testid="registration-page">
      <div>
        <h1 className="font-heading text-2xl sm:text-3xl font-extrabold tracking-tight text-slate-900">
          New Registration
        </h1>
        <p className="text-sm text-muted-foreground mt-1">
          Register a citizen under a district and municipality.
        </p>
      </div>

      <div className="flex flex-col sm:flex-row sm:items-center gap-3 rounded-lg border border-blue-100 bg-blue-50 p-4">
        <div className="flex-1 min-w-0">
          <p className="text-xs font-semibold text-blue-900 uppercase tracking-wide">
            Shareable public registration link
          </p>
          <p className="text-sm text-blue-800 font-mono truncate mt-0.5" data-testid="share-link-url">
            {shareUrl}
          </p>
        </div>
        <Button
          onClick={copyLink}
          variant="outline"
          size="sm"
          className="border-blue-300 text-blue-900 hover:bg-blue-100 shrink-0"
          data-testid="copy-share-link-btn"
        >
          {copied ? <Check className="h-4 w-4 mr-2" /> : <Link2 className="h-4 w-4 mr-2" />}
          {copied ? "Copied" : "Copy Link"}
        </Button>
      </div>

      <RegistrationForm />
    </div>
  );
}
